import React from "react";
import { LoadingSpinner } from 'blueprints2';

function Loading() {
  return (
    <div className="flex justify-center pt-12">
        <LoadingSpinner />
    </div>
  )
}

export default Loading;